import script from "./ProjectList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectList.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectList.vue?vue&type=style&index=0&id=367665c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-367665c4"]])

export default __exports__